module.exports = __webpack_public_path__ + "static/img/cell-phone.f510fc1b.svg";